import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MarketplacePageComponent } from 'src/app/customers/marketplace/marketplace.component';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { Router, NavigationEnd, Event as NavigationEvent } from '@angular/router';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { ToastrService } from 'ngx-toastr';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-nearbyproducts-me',
  templateUrl: './nearbyproducts-me.component.html',
  styleUrls: ['./nearbyproducts-me.component.scss'],
})
export class NearbyproductsMeComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  carouselOptions = {
    spaceBetween: 10,
    slidesPerView: 'auto',
    pagination: false,
  };

  carouselOptionsText = {
    spaceBetween: 10,
    slidesPerView: 4,
    breakpoints: {
      991: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    }
  };

  public commonModalRef: any = null;
  public selectedMemberRegion = '';
  public showEvents = false;
  public isTopPartVisible = false;
  public isUpperMenuVisible = false;
  public search = '';
  private scrollPosition: [number, number] = [0, 0];

  @ViewChild('upperMenu') upperMenu: ElementRef;

  constructor(
    private auth: AuthServiceService,
    private sharedService: SharedService,
    private router: Router,
    private customerService: CustomerService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    @Inject("WINDOW") private window: any,
  ) { }

  get innerWidth() {
    if (!this.sharedService.isBrowser()) return 0;
    return this.window.innerWidth;
  }

  get isOnNearBy() {
    return this.sharedService.isBrowser() && this.window.location.href.includes('/nearby');
  }

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (this.isUpperMenuVisible && this.upperMenu && !this.upperMenu.nativeElement.contains(event.target)) {
      this.isUpperMenuVisible = false;
    }
  }

  openTabManagement() {
    this.sharedService.individualProductsPageSubject.next({ type: 'openTabManagement' });
  }

  handleSearch() {
    this.sharedService.individualProductsPageSubject.next({
      type: 'search',
      val: this.search
    });
  }

  handleReport() {
    this.local.alertReport().then((result) => {
      if (result.isConfirmed && result.value) {
        const { reportDetails, reportType } = result.value;
        this.auth.submitReportMessage({
          message: reportDetails,
          type: reportType
        })
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: () => this.toastr.success('Reported successfully'),
            error: (e) => this.toastr.error(e.error.message)
          });
      }
    });
  }

  onNavigate(url: string) {
    this.scrollPosition = [this.window.scrollX, this.window.scrollY];
    this.router.navigate([`/me/${url}`]);
  }

  ngOnInit(): void {
    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: NavigationEvent) => {
        if (event instanceof NavigationEnd) {
          this.window.scrollTo(this.scrollPosition[0], this.scrollPosition[1]);
        }
      });
  }

  scrollTo(name: string) {
    const element = document.getElementById('carousel-pages');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    if (name === 'news') {
      this.sharedService.triggerInitMembers(0);
    }
    if (name === 'voucher') {
      this.sharedService.triggerInitMembers(2);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
